import React from "react";

import { withModels } from "game_play/utils/store";
import { Number } from '../utils'


class StatsAvg extends React.Component {
  render() {
    const { Game } = this.props
    const { avg } = Game.get('game')

    return (
      <table className="match__info-table">
        <tbody>
        <tr>
          <th colSpan="3">Total</th>
        </tr>
        <tr>
          <td><Number value={avg[0]?.ton00}/></td>
          <td>100+</td>
          <td><Number value={avg[1]?.ton00}/></td>
        </tr>
        <tr>
          <td><Number value={avg[0]?.ton40}/></td>
          <td>140+</td>
          <td><Number value={avg[1]?.ton40}/></td>
        </tr>
        <tr>
          <td><Number value={avg[0]?.ton80}/></td>
          <td>180's</td>
          <td><Number value={avg[1]?.ton80}/></td>
        </tr>
        <tr>
          <td><Number value={avg[0]?.highout}/></td>
          <td>High Finish</td>
          <td><Number value={avg[1]?.highout}/></td>
        </tr>
        <tr>
          <td><Number value={avg[0]?.best}/></td>
          <td>Best Leg</td>
          <td><Number value={avg[1]?.best}/></td>
        </tr>
        <tr>
          <td><Number value={avg[0]?.worst}/></td>
          <td>Worst Leg</td>
          <td><Number value={avg[1]?.worst}/></td>
        </tr>
        <tr>
          <th colSpan="3">Average</th>
        </tr>
        <tr>
          <td><Number value={avg[0]?.darts} fixed={2}/></td>
          <td>Darts</td>
          <td><Number value={avg[1]?.darts} fixed={2}/></td>
        </tr>
        <tr>
          <td><Number value={avg[0]?.score} fixed={2}/></td>
          <td>Score</td>
          <td><Number value={avg[1]?.score} fixed={2}/></td>
        </tr>
        <tr>
          <td><Number value={avg[0]?.first9} fixed={2}/></td>
          <td>First 9</td>
          <td><Number value={avg[1]?.first9} fixed={2}/></td>
        </tr>
        </tbody>
      </table>
    );
  }
}

export default withModels(StatsAvg)